var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbstract3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 585,
    height: 309,
    viewBox: "0 0 585 309",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bi_904_329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.835 261.81C369.605 280.413 482.887 244.51 491.995 181.608L490.133 194.692C481.212 257.404 367.82 293.65 236.954 275.033C106.087 256.416 7.21007 190.632 16.2235 127.273L18.0998 114.085C9.18097 177.063 107.993 243.196 238.835 261.81Z",
    fill: "#E4E8F3",
    fillOpacity: 0.4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bi_904_329)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 255.06,
    cy: 147.759,
    rx: 239.341,
    ry: 115.198,
    transform: "rotate(8.09659 255.06 147.759)",
    fill: "#E4E8F3",
    fillOpacity: 0.4
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_904_329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M473.06 217.635C432.184 255.202 340.998 272.97 239.308 258.504C137.617 244.037 55.0037 201.544 26.2266 154.067C52.5027 202.959 135.724 247.141 238.838 261.81C341.951 276.479 434.191 257.258 473.06 217.635Z",
    fill: "url(#paint0_linear_904_329)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_904_329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M511.107 221.801C502.449 227.906 490.547 225.93 484.524 217.388C478.5 208.846 480.635 196.972 489.293 190.867L462.693 144.618L458.676 147.45C425.716 170.693 417.587 215.898 440.52 248.418C463.453 280.939 508.763 288.46 541.723 265.217L545.74 262.384L511.107 221.801Z",
    fill: "url(#paint1_linear_904_329)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_904_329)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M488.392 214.661C494.416 223.203 506.317 225.179 514.975 219.074L545.591 262.49C512.631 285.733 467.321 278.212 444.389 245.691C421.456 213.171 429.585 167.966 462.545 144.723L493.161 188.14C484.503 194.245 482.368 206.119 488.392 214.661Z",
    fill: "url(#paint2_radial_904_329)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_904_329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462.695 144.62L462.693 144.618C429.733 167.86 421.604 213.065 444.537 245.586C467.47 278.106 512.78 285.627 545.74 262.384L545.738 262.382C512.828 285.134 468.197 277.31 445.398 244.979C422.598 212.647 430.214 167.981 462.695 144.62Z",
    fill: "url(#paint3_linear_904_329)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_bi_904_329)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M506.824 201.664C512.847 210.206 524.749 212.182 533.407 206.076L564.023 249.493C531.063 272.735 485.753 265.214 462.82 232.694C439.888 200.174 448.016 154.969 480.977 131.726L511.593 175.142C502.935 181.247 500.8 193.122 506.824 201.664Z",
    fill: "#E4E8F3",
    fillOpacity: 0.4
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_bi_904_329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.6 134.812L480.617 131.979C447.657 155.222 439.528 200.427 462.461 232.948C485.394 265.468 530.704 272.989 563.664 249.746L559.647 252.579C526.687 275.822 481.377 268.301 458.444 235.78C435.511 203.26 443.64 158.055 476.6 134.812Z",
    fill: "#E4E8F3",
    fillOpacity: 0.4
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_904_329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480.978 131.729L480.977 131.726C448.016 154.969 439.888 200.174 462.82 232.694C485.753 265.214 531.063 272.735 564.023 249.493L564.021 249.49C531.111 272.242 486.48 264.418 463.681 232.087C440.882 199.756 448.497 155.089 480.978 131.729Z",
    fill: "url(#paint4_linear_904_329)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_bi_904_329)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M526.286 187.939C532.31 196.481 544.212 198.457 552.87 192.351L583.486 235.768C550.526 259.01 505.216 251.489 482.283 218.969C459.35 186.449 467.479 141.244 500.439 118.001L531.056 161.417C522.398 167.522 520.263 179.397 526.286 187.939Z",
    fill: "#E4E8F3",
    fillOpacity: 0.4
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_bi_904_329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M496.423 120.834L500.439 118.001C467.479 141.244 459.35 186.449 482.283 218.969C505.216 251.489 550.526 259.01 583.486 235.768L579.469 238.6C546.509 261.843 501.199 254.322 478.266 221.802C455.334 189.281 463.462 144.076 496.423 120.834Z",
    fill: "#E4E8F3",
    fillOpacity: 0.4
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_904_329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500.441 118.004L500.439 118.001C467.479 141.244 459.35 186.449 482.283 218.969C505.216 251.489 550.526 259.01 583.486 235.768L583.484 235.765C550.574 258.517 505.943 250.693 483.144 218.362C460.344 186.031 467.96 141.364 500.441 118.004Z",
    fill: "url(#paint5_linear_904_329)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bi_904_329",
    x: -47.247,
    y: 51.1861,
    width: 602.14,
    height: 291.633,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 31.4497
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_904_329"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_904_329",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.57248
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.57248
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.341176 0 0 0 0 0.352941 0 0 0 0 0.580392 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect2_innerShadow_904_329"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bi_904_329",
    x: -45.3583,
    y: -34.0985,
    width: 600.838,
    height: 363.716,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 31.4497
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_904_329"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_904_329",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.57248
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.57248
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.342674 0 0 0 0 0.352133 0 0 0 0 0.579167 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect2_innerShadow_904_329"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_904_329",
    x: 23.0816,
    y: 150.922,
    width: 453.124,
    height: 118.941,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.57248,
    result: "effect1_foregroundBlur_904_329"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_904_329",
    x: 427.49,
    y: 144.23,
    width: 118.25,
    height: 134.486,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.387411
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.387411
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect1_innerShadow_904_329"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_904_329",
    x: 431.357,
    y: 144.723,
    width: 114.234,
    height: 131.653,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.387411
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.387411
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect1_innerShadow_904_329"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_904_329",
    x: 430.731,
    y: 143.843,
    width: 115.784,
    height: 132.815,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.387411,
    result: "effect1_foregroundBlur_904_329"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_bi_904_329",
    x: 434.293,
    y: 116.23,
    width: 145.227,
    height: 162.258,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.74822
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_904_329"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_904_329",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.387411
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.387411
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.342674 0 0 0 0 0.352133 0 0 0 0 0.579167 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect2_innerShadow_904_329"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_bi_904_329",
    x: 429.918,
    y: 116.483,
    width: 149.243,
    height: 165.091,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.74822
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_904_329"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_904_329",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.387411
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.387411
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.341176 0 0 0 0 0.352941 0 0 0 0 0.580392 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect2_innerShadow_904_329"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_904_329",
    x: 449.014,
    y: 130.951,
    width: 115.784,
    height: 132.815,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.387411,
    result: "effect1_foregroundBlur_904_329"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_bi_904_329",
    x: 453.756,
    y: 102.505,
    width: 145.227,
    height: 162.258,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.74822
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_904_329"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_904_329",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.387411
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.387411
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.342674 0 0 0 0 0.352133 0 0 0 0 0.579167 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect2_innerShadow_904_329"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_bi_904_329",
    x: 449.74,
    y: 102.505,
    width: 149.243,
    height: 165.091,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.74822
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_904_329"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_904_329",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.387411
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.387411
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.341176 0 0 0 0 0.352941 0 0 0 0 0.580392 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect2_innerShadow_904_329"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_904_329",
    x: 468.477,
    y: 117.226,
    width: 115.784,
    height: 132.815,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.387411,
    result: "effect1_foregroundBlur_904_329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_904_329",
    x1: 34.3324,
    y1: -0.000508181,
    x2: 508.243,
    y2: 67.4183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.130208,
    stopColor: "white",
    stopOpacity: 0.865636
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "white",
    stopOpacity: 0.494792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_904_329",
    x1: 460.458,
    y1: 146.194,
    x2: 543.505,
    y2: 263.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6DB63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681928,
    stopColor: "#DAC46E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6E979"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_904_329",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(462.845 150.022) rotate(54.8093) scale(126.09 127.795)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6DB63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6E979"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_904_329",
    x1: 579.712,
    y1: 56.7566,
    x2: 667.791,
    y2: 181.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.130208,
    stopColor: "white",
    stopOpacity: 0.865636
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "white",
    stopOpacity: 0.494792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_904_329",
    x1: 597.995,
    y1: 43.8649,
    x2: 686.074,
    y2: 168.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.130208,
    stopColor: "white",
    stopOpacity: 0.865636
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "white",
    stopOpacity: 0.494792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_904_329",
    x1: 617.458,
    y1: 30.1399,
    x2: 705.537,
    y2: 155.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.130208,
    stopColor: "white",
    stopOpacity: 0.865636
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "white",
    stopOpacity: 0.494792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbstract3);
export default __webpack_public_path__ + "static/media/abstract3.8a3a1434cac21e32fe5298abedbffc09.svg";
export { ForwardRef as ReactComponent };